









































import {Component, Vue, Provide, Prop} from 'vue-property-decorator';
import widgetStoreModule from '@/store/modules/widgetModule';
import SimpleDialog from '@c/SimpleDialog.vue';
import WidgetSettingsForm from '@c/widgets/base/WidgetSettingsForm.vue';
import {uuidv4} from '@/utils/uuidUtils';
import {WidgetSettings} from './widgets/base/bindForms/interfaces';
import {WidgetCard} from '@v/dashboard/interfaces';
import {MeasurementData} from '@/views/system/measurements/interfaces';

@Component({
  components: {
    SimpleDialog,
    WidgetSettingsForm,
  },
})
export default class Widget extends Vue {
  // TODO: контекстное меню нужно будет вынести в отдельную компоненту

  // Объект виджета
  @Provide()
  @Prop({required: false})
  widget!: WidgetCard;

  @Provide()
  @Prop()
  measurements!: MeasurementData[];

  // необходимо передать в виджет количество столбцов, чтобы при переходе через breakpoint и изменении количества столбцов перерисовывать графики на виджете
  @Prop({required: false})
  colNum!: number;

  // Модель диалога с настройками
  settingsDialog = false;

  // Выбранный пункт контекстного меню
  selectedContextMenuItem = null;

  // Модель контекстного меню
  contextMenu = false;

  // Координаты контекстного меню
  contextMenuX = 0;
  contextMenuY = 0;

  // Действия при показе контекстного меню
  showContextMenu(e: any) {
    this.selectedContextMenuItem = null;
    e.preventDefault();
    this.contextMenu = false;
    this.contextMenuX = e.clientX;
    this.contextMenuY = e.clientY;
    this.$nextTick(() => {
      this.contextMenu = true;
    });
  }

  // Действия при выборе настроек (Изменение либо Сохранение)
  async onSettingsSelect() {
    //Сохранение настроек виджета
    const settings = (this.$refs.settingsForm as any).settings as WidgetSettings;

    const widget = {...this.widget};
    widget.settings = {...settings};
    widget.name = settings.name;
    widget.id = uuidv4();
    await widgetStoreModule.saveEditWidget(widget);
    this.$emit('onSaveWidgetTemplate', this.widget, widget);
    this.$emit('setItemCoordinates', widget);
  }

  updateGrid() {
    this.$emit('updateGrid');
  }
}
